import React from "react";
import {  useBox } from "@react-three/cannon";


function BoxOne() {
  const [ref, api] = useBox(() => ({ mass: 1, position: [0, 2, 0] }));
  return (
    <mesh
      onClick={() => {
        api.velocity.set(0, 6, 0);
      }}
      ref={ref}
    
    >
      <boxBufferGeometry attach="geometry" />
      <meshLambertMaterial attach="material" color="hotpink" />
    </mesh>
  );
}
export default BoxOne;